module.exports = __webpack_public_path__ + "1dc35d25e61d819a9c357074014867ab.ttf";